module.exports = __webpack_public_path__ + "img/logo.ca2a79cc.svg";